import { IEventAggregationService, ISubscriber } from "@studyportals/event-aggregation-service-interface";
import { SearchPageClearFiltersEvent } from "@studyportals/search-page-interface";
import { Product, Tracker } from '@studyportals/datalake-event-tracker';

export class HeaderSearch implements ISubscriber<SearchPageClearFiltersEvent> {

	public static readonly instance = new HeaderSearch();

	private readonly WHAT_INPUT_SELECTOR = '.js-what';
	private readonly WHERE_INPUT_SELECTOR = '.js-where';
	private readonly SEARCH_INPUT_SELECTOR = '.js-searchBox';
	private readonly eventAggregationService: IEventAggregationService | undefined;
	private readonly tracker: Tracker;
	public constructor() {
		this.tracker = new Tracker(Product.EXPERIMENT,false,true);
		this.eventAggregationService = window.EventAggregationService || undefined;
	}

	public initialize(): void {
		const url = new URL(window.location.href);
		const searchParams = new URLSearchParams(url.search);

		this.setKeyword(searchParams, 'kw-what', this.WHAT_INPUT_SELECTOR);
		this.setKeyword(searchParams, 'kw-where', this.WHERE_INPUT_SELECTOR);

		this.eventAggregationService?.subscribeTo(SearchPageClearFiltersEvent.EventType, this, true);

		this.normalizeInput();
	}

	private normalizeInput(): void {
		const searchBoxes = document.querySelectorAll<HTMLInputElement>(this.SEARCH_INPUT_SELECTOR);

		searchBoxes.forEach(input => {
			input.addEventListener('input', event => {
				const target = event.target as HTMLInputElement;
				// Replace "&" with ' and ' and collapse multiple spaces into one
				target.value = target.value.replace(/&/g, ' and ').replace(/\s\s+/g, ' ');
			});
		});
	}

	private setKeyword(searchParams: URLSearchParams, searchParam: string, inputSelector: string): void {
		if (searchParams && searchParams.has(searchParam)) {
			const value = searchParams.get(searchParam);
			if (value === null) {
				return;
			}

			const keywordSearchBox = document.querySelector<HTMLInputElement>(inputSelector);
			if (keywordSearchBox === null) {
				return;
			}

			keywordSearchBox.value = value;
		}
	}

	private setKeywordEmpty(inputSelector: string): void {
		const keywordSearchBox = document.querySelector<HTMLInputElement>(inputSelector);
		if (keywordSearchBox === null) {
			return;
		}

		keywordSearchBox.value = '';
	}

	public notify(event: SearchPageClearFiltersEvent): void {
		if(SearchPageClearFiltersEvent.is(event)) {
			const whatSearchBox = document.querySelector<HTMLInputElement>(this.WHAT_INPUT_SELECTOR);
			const whereSearchBox = document.querySelector<HTMLInputElement>(this.WHERE_INPUT_SELECTOR);

			const whatSearchType = whatSearchBox?.getAttribute('data-search-type');
			const whereSearchType = whereSearchBox?.getAttribute('data-search-type');

			if(whatSearchType === 'discipline' && event.filters.includes('di')) {
				this.setKeywordEmpty(this.WHAT_INPUT_SELECTOR);
			}

			if(whatSearchType === null && event.filters.includes('kw-what')) {
				this.setKeywordEmpty(this.WHAT_INPUT_SELECTOR);
			}

			if(whereSearchType === 'organisation' && event.filters.includes('oi')) {
				this.setKeywordEmpty(this.WHERE_INPUT_SELECTOR);
			}

			if(whereSearchType === 'country' && event.filters.includes('ci')) {
				this.setKeywordEmpty(this.WHERE_INPUT_SELECTOR);
			}

			if(whereSearchType === 'region' && event.filters.includes('rg')) {
				this.setKeywordEmpty(this.WHERE_INPUT_SELECTOR);
			}

			if(whereSearchType === null && event.filters.includes('kw-where')) {
				this.setKeywordEmpty(this.WHERE_INPUT_SELECTOR);
			}
		}
	}
}

document.addEventListener('DOMContentLoaded', () => {
	HeaderSearch.instance.initialize();
})
